module.exports = __webpack_public_path__ + "img/1.ae97d75b.png";